import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import { customGlobalFilter } from "utils/common-helpers"
import {
  credentialColumns,
  searchColumns,
} from "utils/columns/ElementsColumns/searchColumns"
import viewImg from "../../assets/images/Inventory/viewImg.jpg"
import secureLocalStorage from "react-secure-storage"

function TableContainer({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table
  const [search, setSearch] = useState(true)

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-bodys">
            <div className="d-flex justify-content-between mb-2 mt-3">
              <div className="col-md-12">
                {search ? (
                  <div className="d-flex justify-content-between col-md-12">
                    <div className="col-1 me-md-5">
                      <select
                        className="border-radius form-select"
                        style={{ width: "100px" }}
                        value={pageSize}
                        onChange={e => setPageSize(e.target.value)}
                      >
                        {[10, 25, 50, 100].map(pageSize => (
                          <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                      <div className="position-relative">
                        <label htmlFor="search-bar-0" className="search-label">
                          <span id="search-bar-0-label" className="sr-only">
                            Search this table
                          </span>
                          <input
                            onChange={e => setGlobalFilter(e.target.value)}
                            id="search-bar-0"
                            type="text"
                            className=" form-control rounded h-100"
                            placeholder={` Search...`}
                            value={globalFilter || ""}
                          />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {data?.length != 0 ? (
              <>
                <div className="position-relative table-responsive search-history-slots">
                  <Table
                    className="table table-bordered mt-4"
                    {...getTableProps()}
                  >
                    <thead className={``}>
                      {headerGroups.map((headerGroup, i) => (
                        <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column, index) => (
                            <th
                              key={index}
                              className={`t-col-${index + 1} ${
                                column.className
                              }`}
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                            >
                              <div className="d-flex align-items-center">
                                <span className="flex-grow-1 text-center header-text">
                                  {column.render("Header")}
                                </span>
                                {column.isShortIcon && (
                                  <span
                                    onClick={() =>
                                      column.getSortByToggleProps().onClick()
                                    }
                                    className="d-flex align-items-center ms-2"
                                  >
                                    <i
                                      title="Ascending"
                                      className={`bi bi-arrow-up info-icon ${
                                        column.isSorted && !column.isSortedDesc
                                          ? "text-dark"
                                          : ""
                                      }`}
                                    ></i>
                                    <i
                                      title="Descending"
                                      className={`bi bi-arrow-down info-icon ${
                                        column.isSorted && column.isSortedDesc
                                          ? "text-dark"
                                          : ""
                                      }`}
                                    ></i>
                                  </span>
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody
                      className="fix-introducer-header"
                      {...getTableBodyProps()}
                    >
                      {page.map((row, i) => {
                        prepareRow(row)
                        return (
                          <tr
                            className={`row-hover`}
                            {...row.getRowProps()}
                            key={i}
                          >
                            {row.cells.map((cell, index) => {
                              return (
                                <td
                                  key={index}
                                  className={`t-col-${index + 1} ${
                                    cell.column.className
                                  }`}
                                  {...cell.getCellProps()}
                                >
                                  {cell.render("Cell")}
                                </td>
                              )
                            })}
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>

                <Row className="justify-content-md-end justify-content-center align-items-center">
                  <NewPagination
                    gotoPage={gotoPage}
                    canPreviousPage={canPreviousPage}
                    previousPage={previousPage}
                    canNextPage={canNextPage}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                    pageSize={pageSize}
                    page={page}
                    data={data}
                    nextPage={nextPage}
                  />
                </Row>
              </>
            ) : (
              <div className="d-flex flex-column align-items-center justify-content-center p-3">
                <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                  <img src={viewImg} alt="Image" width={200} />
                  <p className="text-purple fw-bold text-center lh-base">
                    🔍 Your Data Search is Ready! Use the selected module
                    filters to search and explore relevant data across the
                    entire application with ease. 📂📈
                  </p>
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

const CredentailSearch = ({ allData, searchValue, isSearch, mainAllData }) => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const token = secureLocalStorage.getItem("auth_token")
  const toggleLoading = loading => {
    setLoading(loading)
  }
  const column1 = useMemo(() => credentialColumns(), [])
  useEffect(() => {
    const filteredTabs = []
    if (isSearch) {
      mainAllData.forEach(tab => {
        const matchingCredentials = []

        tab.credentials.forEach(credential => {
          let matchedValue = null

          Object.keys(credential).forEach(key => {
            const value = credential[key]

            if (
              value !== null &&
              typeof value !== "object" &&
              value.toString().toLowerCase().includes(searchValue)
            ) {
              matchedValue = value.toString() // First match
            }
          })
          if (matchedValue !== null) {
            const firstKey = Object.keys(credential)[0] // Gets the first key
            const firstValue = credential[firstKey]
            matchingCredentials.push({
              credential_id: credential.id,
              credentials: matchedValue,
              credentialColmn: firstValue,
            })
          }
        })

        // console.log(matchingCredentials)
        if (matchingCredentials.length > 1) {
          matchingCredentials.forEach(match => {
            filteredTabs.push({
              ...tab,
              credentials: match.credentials,
              credential_id: match.credential_id,
              credentialColmn: match?.credentialColmn,
            })
          })
        } else if (matchingCredentials.length === 1) {
          filteredTabs.push({
            ...tab,
            credentials: matchingCredentials[0]?.credentials,
            credential_id: matchingCredentials[0]?.credential_id,
            credentialColmn: matchingCredentials[0]?.credentialColmn,
          })
        }
      })
 
      setData(filteredTabs)
    }
  }, [searchValue, isSearch])
  // console.log(data)
  return (
    <React.Fragment>
      <>
        {isLoading && <Loader />}
        <div className="">
          <div>
            <Row>
              <Col lg="12">
                <Card>
                  <div className="responsive-table">
                    <TableContainer
                      columns={column1}
                      data={data}
                      toggleLoading={toggleLoading}
                      token={token}
                      setData={setData}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </>
    </React.Fragment>
  )
}

export default CredentailSearch
